import ColorThief from 'colorthief';

export const analyzeColors = async (imageFile) => {
  return new Promise((resolve) => {
    const img = new Image();
    const colorThief = new ColorThief();

    img.onload = () => {
      try {
        // Daha fazla renk al (8 renk)
        const palette = colorThief.getPalette(img, 8);

        // RGB'den HEX'e çevir ve renkleri analiz et
        const colors = palette.map(rgb => ({
          hex: `#${rgb.map(x => {
            const hex = x.toString(16);
            return hex.length === 1 ? '0' + hex : hex;
          }).join('')}`,
          brightness: (rgb[0] * 299 + rgb[1] * 587 + rgb[2] * 114) / 1000,
          saturation: calculateSaturation(rgb)
        }));

        // Renkleri parlaklık ve doygunluğa göre sırala
        const sortedColors = [...colors].sort((a, b) => {
          // Önce doygunluğa göre sırala
          const satDiff = b.saturation - a.saturation;
          if (Math.abs(satDiff) > 0.1) return satDiff;
          // Sonra parlaklığa göre sırala
          return b.brightness - a.brightness;
        });

        // En doygun rengi ana renk olarak kullan
        const primaryColor = sortedColors[0].hex;
        
        // İkinci en yaygın rengi açık arka plan rengi olarak kullan
        const secondaryColor = colors[1].hex;
        
        // Kontrast rengi bul
        const accentColor = findContrastingColor(sortedColors);

        // Renkleri tema değişkenlerine dönüştür
        const wheelColors = {
          // Çark arkaplan renkleri - ikinci renk daha açık olmalı
          backgroundColor1: primaryColor,
          backgroundColor2: secondaryColor,
          
          // Çark yazı renkleri - okunabilirlik için otomatik kontrast
          textColor1: getContrastColor(primaryColor),
          textColor2: getContrastColor(secondaryColor),
          
          // Çark kenar ve işaretçi renkleri
          borderColor: accentColor,
          pointerColor: accentColor,
          radiusLineColor: secondaryColor,
          
          // Buton renkleri
          buttonGradient1: primaryColor,
          buttonGradient2: secondaryColor,
          buttonTextColor: getContrastColor(secondaryColor),
          buttonBorderColor: accentColor,
          buttonGlowColor: accentColor,
          
          // Devre dışı buton renkleri
          buttonDisabled1: adjustColorBrightness(primaryColor, -40),
          buttonDisabled2: adjustColorBrightness(secondaryColor, -40),
          buttonDisabledText: adjustColorBrightness(accentColor, -30),
          buttonDisabledBorder: adjustColorBrightness(accentColor, -40)
        };

        resolve(wheelColors);
      } catch (error) {
        console.error('Renk analizi hatası:', error);
        resolve(getDefaultColors());
      }
    };

    img.src = URL.createObjectURL(imageFile);
  });
};

// Rengin doygunluğunu hesapla (0-1 arası)
const calculateSaturation = ([r, g, b]) => {
  const max = Math.max(r, g, b);
  const min = Math.min(r, g, b);
  return max === 0 ? 0 : (max - min) / max;
};

// Verilen renklerden en iyi kontrast rengi bul
const findContrastingColor = (colors) => {
  // İlk iki renkle en iyi kontrast oluşturan rengi bul
  const primary = colors[0].hex;
  const secondary = colors[1].hex;
  
  return colors.slice(2).reduce((best, current) => {
    const currentContrast = getColorContrast(current.hex, primary) + 
                          getColorContrast(current.hex, secondary);
    const bestContrast = getColorContrast(best.hex, primary) + 
                        getColorContrast(best.hex, secondary);
    return currentContrast > bestContrast ? current : best;
  }, colors[2]).hex;
};

// İki renk arasındaki kontrast oranını hesapla
const getColorContrast = (hex1, hex2) => {
  const rgb1 = hexToRgb(hex1);
  const rgb2 = hexToRgb(hex2);
  const l1 = 0.2126 * rgb1[0] + 0.7152 * rgb1[1] + 0.0722 * rgb1[2];
  const l2 = 0.2126 * rgb2[0] + 0.7152 * rgb2[1] + 0.0722 * rgb2[2];
  const brightest = Math.max(l1, l2);
  const darkest = Math.min(l1, l2);
  return (brightest + 0.05) / (darkest + 0.05);
};

// Kontrast rengi hesapla
const getContrastColor = (hexcolor) => {
  const rgb = hexToRgb(hexcolor);
  const brightness = (rgb[0] * 299 + rgb[1] * 587 + rgb[2] * 114) / 1000;
  return brightness > 128 ? '#000000' : '#FFFFFF';
};

// Varsayılan renkleri döndür
const getDefaultColors = () => ({
  backgroundColor1: '#1A2234',
  backgroundColor2: '#2E4057',
  textColor1: '#FFFFFF',
  textColor2: '#F3F4F6',
  borderColor: '#09F984',
  pointerColor: '#09F984',
  radiusLineColor: '#2E4057',
  buttonGradient1: '#1A2234',
  buttonGradient2: '#2E4057',
  buttonTextColor: '#FFFFFF',
  buttonBorderColor: '#09F984',
  buttonGlowColor: '#09F984',
  buttonDisabled1: '#0D1117',
  buttonDisabled2: '#1A2234',
  buttonDisabledText: '#4A5568',
  buttonDisabledBorder: '#2D3748'
});

// Yardımcı fonksiyon: Renk parlaklığını ayarla
const adjustColorBrightness = (hex, percent) => {
  const rgb = hexToRgb(hex);
  const adjusted = rgb.map(color => {
    const newValue = Math.max(0, Math.min(255, color + (color * percent / 100)));
    return Math.round(newValue);
  });
  
  return `#${adjusted.map(x => {
    const hex = x.toString(16);
    return hex.length === 1 ? '0' + hex : hex;
  }).join('')}`;
};

// Yardımcı fonksiyon: HEX'i RGB'ye çevir
const hexToRgb = (hex) => {
  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  return result ? 
    [parseInt(result[1], 16), parseInt(result[2], 16), parseInt(result[3], 16)] : 
    [0, 0, 0];
}; 